import { Component, Input, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { BaseComponent } from '@classes/extends';
import { FicheclientService as FicheClientService, Race } from '@estel-numerique/galaclick-api';
import { ValidatorDateService, ValidatorPatternService } from '@estel-numerique/galaclick-core';
import { Constantes } from '@services/util/constantes';
import { lastValueFrom } from 'rxjs';
import { FicheClientAteliersComponent, FicheClientAteliersComponentData } from './ficheclient-ateliers/ficheclient-ateliers.component';
import { AddButton } from '../../../composants/composants';
import { CpIconUL, CpIconAtelier, CpIconAtelierNotInGalaRace } from '../../../composants/icons/icons.component';
import { ButtonGalaDeleteComponent } from '../../../composants/buttons/btn-gala-delete/btn-gala-delete.component';


@Component({
    selector: 'client-races',
    templateUrl: 'ficheclient-races.component.html',
    imports: [AddButton, CpIconUL, CpIconAtelier, CpIconAtelierNotInGalaRace, ButtonGalaDeleteComponent]
})
export class FicheClientRacesComponent extends BaseComponent implements OnInit {
    public validDate = inject(ValidatorDateService);
    public validPattern = inject(ValidatorPatternService);
    private formBuilder = inject(UntypedFormBuilder);
    private wsFicheClient = inject(FicheClientService);
    private dialog = inject(MatDialog);

    public codeModule: string = Constantes.CodeOption.CFICHECLIENT;

    @Input() public titre: string;

    public races: Race[];
    public idClient: number;
    public formAjout: UntypedFormGroup;
    public listeHistoRaces: Race[] = [];
    protected lgTrad: Record<string, string>;

    constructor() {
        super();
        this.formAjout = this.formBuilder.group({
            TYPESERV: [null, [Validators.required]]
        });
        this.lgTrad = {
            ENGAGEMENTS: this.translate.instant("APPFICHECLIENT.COLTAB.ENGAGEMENTS"),
            RACEELE: this.translate.instant("APPFICHECLIENT.COLTAB.RACEELE"),
            CODE: this.translate.instant("APPFICHECLIENT.COLTAB.CODE"),
            NOM: this.translate.instant("NOM"),
            PRODUCTION: this.translate.instant("APPFICHECLIENT.COLTAB.PRODUCTION"),
            INUL: this.translate.instant("APPFICHECLIENT.COLTAB.INUL"),
            ATELIERLAIT: this.translate.instant("APPFICHECLIENT.COLTAB.ATELIERLAIT"),
            HISTORACES: this.translate.instant("APPFICHECLIENT.HISTORACES"),
            RET: this.translate.instant("RET"),
        };
    }


    // =========================================================================
    // CHARGEMENT CONTEXTE
    // =========================================================================

    ngOnInit(): void {
        super.ngOnInit();
    }

    initialiseRaces(races: Race[], idClient: number) {
        this.races = races;
        this.idClient = idClient;
    }

    public openAjouterRaces() {
        this.openModalRace({ idClient: this.idClient, listeRaces: this.races, fromhisto: false });
    }

    public openEditRace(race: Race) {
        this.openModalRace({ idClient: this.idClient, listeRaces: this.races, fromhisto: false, race: race });
    }

    public openEditRaceFromHisto(race: Race) {
        this.openModalRace({ idClient: this.idClient, listeRaces: this.listeHistoRaces, fromhisto: true, race: race });
    }
    private openModalRace(oData: FicheClientAteliersComponentData) {
        const dialogRace = this.dialog.open(FicheClientAteliersComponent, { data: oData });
        dialogRace.componentInstance.savedCreate.subscribe((races) => {
            this.savedCreate(races);
        });
        dialogRace.componentInstance.savedUpdate.subscribe((race) => {
            this.savedUpdate(race);
        });
    }

    public savedUpdate(race: Race) {
        const index = this.races.findIndex((r: Race) => {
            return r.RFRACE.CORABO == race.RFRACE.CORABO;
        });
        if (index > -1) {
            this.races.splice(index, 1, race);
        } else {
            this.races.push(race);
        }
    }

    public savedCreate(races: Race[]) {
        races.forEach((r: Race) => {
            this.races.push(r);
        });
    }

    async switchAtelierRace(race: Race) {
        if (this.isAccessWrite()) {
            this.util.showLoader();
            race.ATLAIT = race.ATLAIT === '0' ? '1' : '0';
            try {
                await this.wsFicheClient.updateRace(race.IDCLIENT, race).toPromise();
            } catch (e) {
                this.util.fErreur(e);
            }
            this.util.hideLoader();
        }
    }

    async deleteRace(race: Race) {
        this.util.showLoader();
        try {
            await this.wsFicheClient.deleteRace(race.IDRACECLIENT).toPromise();
            if (!this.raceSource(race, 'FCM')) {
                const index = this.races.indexOf(race);
                if (index != -1) {
                    this.races.splice(this.races.indexOf(race), 1);
                }
            } else {
                const oldSource = JSON.parse(race.SOURCE) as string[];
                oldSource.splice(oldSource.indexOf("GR"));
                race.SOURCE = JSON.stringify(oldSource);
            }
        } catch (e) {
            this.util.fErreur(e);
        }
        this.util.hideLoader();
    }


    async enregistrerRaceDansGalaRace(race: Race) {
        if (this.isAccessWrite()) {
            this.util.showLoader();
            try {
                race.ATLAIT = race.PRESENCEUL === 0 ? '1' : '0';
                const oldSource = JSON.parse(race.SOURCE) as string[];
                oldSource.push('GR');
                race.SOURCE = JSON.stringify(oldSource);
                const listeRace = [race];
                const listeDesRacesPost = await lastValueFrom(this.wsFicheClient.postRace(race.IDCLIENT, listeRace));
                // récupération de l'id race client dans la liste des races
                listeDesRacesPost.forEach((lRace: Race) => {
                    //si le code de la race est le même que celui récupéré de la fcm, alors on recuperel'idraceclient
                    if (lRace.RFRACE.CORABO == race.RFRACE.CORABO) {
                        race.IDRACECLIENT = lRace.IDRACECLIENT;
                    }
                });
            } catch (e) {
                this.util.fErreur(e);
            }
            this.util.hideLoader();
        }
    }

    public raceSource(race: Race, source: string): boolean {
        return (JSON.parse(race.SOURCE) as string[]).find((item: string) => item === source) !== undefined;
    }
}
